// extracted by mini-css-extract-plugin
export default {"footer":"TemplateFooter_footer__npfCW","buttonToOpen":"TemplateFooter_buttonToOpen__OWIoc"};